import { get, patch } from 'vio-libs';
export function getLockerNetworkInterfaces(deviceID, organizationSlug) {
    return get(`network-interfaces?organization=${organizationSlug}&device_id=${deviceID}`);
}
export function getMarketNetworkInterfaces(edgeMarket, organizationSlug) {
    return get(`network-interfaces?organization=${organizationSlug}&edge_market=${edgeMarket}`);
}
export function getSiteNetworkInterfaces(organization, locationSlug) {
    const { slug: organizationSlug } = organization;
    return get(`network-interfaces?organization=${organizationSlug}&location=${locationSlug}`);
}
export function getNetworkInterface(organization, deviceID, interfaceID) {
    return get(`network-interfaces?organization=${organization}&device_id=${deviceID}&interface_id=${interfaceID}`);
}
export function getOrgNetworkInterfaces(organizationSlug) {
    return get(`network-interfaces?organization=${organizationSlug}`);
}
export function patchNetworkInterface(location, organization, deviceID, interfaceID, description) {
    return patch(`network-interfaces?organization=${organization}&location=${location}`, {
        data: {
            description,
            device_id: deviceID,
            interface_id: interfaceID
        }
    });
}
